import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

let isRefreshing = false;

export const jwtInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);

  const token = authService.getToken();

  // Inject x-access-token header from sessionStorage (primary auth)
  // Also add withCredentials for httpOnly cookie fallback (WEB-01)
  let headers = req.headers;
  if (token) {
    headers = headers.set('x-access-token', token);
  }
  req = req.clone({
    withCredentials: true,
    headers
  });

  return next(req).pipe(
    catchError(err => {
      if (err.status === 401 && !req.url.includes('/refresh-token')) {
        if (!isRefreshing) {
          isRefreshing = true;
          return authService.refreshToken().pipe(
            switchMap((res: any) => {
              isRefreshing = false;
              if (res && !res.error) {
                authService.updateToken(res.data?.token, res.data);
                return next(req.clone());
              }
              authService.logout();
              return throwError(err);
            }),
            catchError(() => {
              isRefreshing = false;
              authService.logout();
              return throwError(err);
            })
          );
        }
      }
      // Validator/idempotency failures come back as `{ success: false, errors: [{ msg }] }`
      // with no top-level `message`, so without the `errors[0].msg` fallback the operator
      // only ever saw "Bad Request".
      const msg =
        err?.error?.message ||
        err?.error?.errors?.[0]?.msg ||
        err.statusText ||
        'Unexpected error';
      return throwError(msg);
    })
  );
};
